import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

function Clock(props) {
  const { format } = props;
  const [datetime, setDatetime] = useState(moment()
    .format(format));

  const tick = () => {
    setDatetime(moment()
      .format(format));
  };

  useEffect(() => {
    const timerID = setInterval(() => tick(), 1000);
    return function cleanUp() {
      clearInterval(timerID);
    };
  });

  return (
    <span>
      {' '}
      {datetime}
      {' '}
    </span>
  );
}

Clock.propTypes = {
  format: PropTypes.string
};
Clock.defaultProps = {
  format: 'ddd, Do MMM YYYY, H:mm'
};

export default Clock;
